import { state } from 'cerebral';

export default get => {
  const sections = get(state`admin.structure.structureForm.sections`) || {};

  return Object.values(sections).every(
    ({ teams }) => Object.keys(teams || {}).length > 0
  );
};
